import Image from 'next/image';
import Link from 'next/link';
import Heading from '@/components/elements/Heading';

export default function PostCard({
  title,
  excerpt,
  link,
  image,
  readMoreText,
}: {
  title: string;
  excerpt: string;
  link: string;
  image?: string;
  readMoreText: string;
}) {
  return (
    <div className="flex flex-col space-y-3 rounded-xl border border-[#EEEEEE] bg-white p-8 sm:h-135 sm:max-h-140">
      <Link href={link} className="block">
        <div className="relative aspect-video w-full shrink-0 overflow-hidden rounded-lg">
          <Image
            src={image || ''}
            alt={''}
            fill
            className="rounded-lg object-cover"
            sizes="(min-width: 1024px) 360px, (min-width: 640px) 50vw, 100vw"
            quality={100}
          />
        </div>
      </Link>
      <Link href={link} className="hover:underline">
        <Heading
          text={title}
          variant="h5"
          className="font-source-serif-pro text-[#2E2B26]"
        />
      </Link>
      <div
        dangerouslySetInnerHTML={{ __html: excerpt }}
        className="text-graphite-400 line-clamp-5 overflow-hidden"
      />
      <Link
        href={link}
        className="mt-auto block rounded border border-teal-700/30 py-2 text-center font-semibold text-teal-700 transition hover:border-teal-700 hover:bg-teal-700 hover:text-white"
      >
        {readMoreText}
      </Link>
    </div>
  );
}
